import taxesService from '@/modules/payments/services/taxesService';

const PAGE_SIZE = 25;

const state = {
  taxes: [],
  isLoaded: false,
};

const getters = {
  taxes: (state) => state.taxes,
  isLoaded: (state) => state.isLoaded,
};

const mutations = {
  setTaxes(state, taxes) {
    state.taxes = taxes;
  },
  setIsLoaded(state, isLoaded) {
    state.isLoaded = isLoaded;
  },
};

const actions = {
  async loadTaxes({ commit }) {
    let hasMore = true;
    let page = 1;
    const taxesArray = [];
    /* eslint-disable no-await-in-loop */
    while (hasMore) {
      const taxes = await taxesService.taxList(page, PAGE_SIZE);
      Array.prototype.push.apply(taxesArray, taxes.data.data.taxes);
      if (taxes.data.data.taxes.length === PAGE_SIZE) {
        hasMore = true;
        page += 1;
      } else {
        hasMore = false;
      }
    }
    /* eslint-disable no-await-in-loop */
    commit('setTaxes', taxesArray);
    commit('setIsLoaded', true);
    return taxesArray;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
